import { render, staticRenderFns } from "./AiCyclingCoach.vue?vue&type=template&id=79cf9636&"
import script from "./AiCyclingCoach.vue?vue&type=script&lang=js&"
export * from "./AiCyclingCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports